import { createSelector } from 'reselect';

// Config
import { getConfigFeaturesSelector } from '@redux/reducers/config/configSelector';
import {
  getConfirmationIsClickCollectOrderSelector,
  getConfirmationIsMultiBatchSelector,
  getConfirmationOrderAmountsSelector,
  getConfirmationOrderDeliveriesSelector,
} from '@redux/reducers/confirmation/orderConfirmationSelector';
import {
  getApplyRewardsApiCallActiveSelector,
  getOrderFormAmountsSelector,
  getOrderFormIsClickCollectOrderSelector,
  getOrderFormIsGiftReceiptOrderSelector,
  getOutstandingBalanceExcludingDeliveryChargeRawSelector,
} from '@redux/reducers/order-form/orderFormSelector';

const orderTotalsOrderFormState = createSelector(
  [
    getOrderFormAmountsSelector,
    getOrderFormIsGiftReceiptOrderSelector,
    getOrderFormIsClickCollectOrderSelector,
    getApplyRewardsApiCallActiveSelector,
    getConfigFeaturesSelector,
    getOutstandingBalanceExcludingDeliveryChargeRawSelector,
  ],
  (
    amounts,
    isGiftReceiptOrder,
    isClickCollectOrder,
    applyRewardsApiCallActive,
    _configFeatures,
    outstandingBalanceExcludingDeliveryChargeRaw,
  ) => ({
    amounts,
    applyRewardsApiCallActive,
    isGiftReceiptOrder,
    isClickCollectOrder,
    outstandingBalanceExcludingDeliveryChargeRaw,
  }),
);

const orderTotalsConfirmationPagePropsState = createSelector(
  [
    getConfirmationOrderAmountsSelector,
    getConfirmationIsMultiBatchSelector,
    getConfirmationOrderDeliveriesSelector,
    getConfirmationIsClickCollectOrderSelector,
    getApplyRewardsApiCallActiveSelector,
    getConfigFeaturesSelector,
  ],
  (amounts, isMultiBatch, deliveries, isClickCollectOrder, applyRewardsApiCallActive) => ({
    amounts,
    applyRewardsApiCallActive,
    isGiftReceiptOrder: !isMultiBatch && (deliveries?.some((delivery) => delivery.isGiftReceiptOrder) ?? false),
    isClickCollectOrder,
    outstandingBalanceExcludingDeliveryChargeRaw: undefined,
  }),
);

export { orderTotalsConfirmationPagePropsState, orderTotalsOrderFormState };
